import React from "react";
import SEO from "../components/SEO";
import HeroInner from "../components/HeroInner/HeroInner";
import Services from "../components/Services";
import ChatBot from "../components/ChatBot";
import GlobalScripts from "../components/GlobalScripts";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer";
import "./DesarrolloWeb.css";

function CMS() {
  return (
    <>
      <SEO
        title="CMS y Contenidos | WordPress, Elementor y Avada"
        description="Gestión de contenidos profesional con WordPress, Elementor y Avada. Sitios fáciles de administrar y optimizados."
        url="https://juancarlosmancharamos.ar/cms"
      />

      <Menu />

      <HeroInner
        title="CMS y Contenidos"
        subtitle="WordPress, Elementor y Avada para gestionar tu web de forma simple"
        bg="/assets/images/bg-dev.jpg"
      />

      <section className="container dev-section">
        <h2>Gestión web simple y profesional</h2>

        <p>
          Desarrollo sitios autoadministrables con WordPress, permitiéndote
          actualizar contenidos sin conocimientos técnicos.
        </p>

        <p>
          Utilizo constructores visuales como Elementor y Avada para crear
          páginas modernas, flexibles y optimizadas.
        </p>

        <h3>Ventajas</h3>

        <p>
          Edición fácil, escalabilidad, integración con plugins y control total
          sobre tu contenido.
        </p>
      </section>

      <section id="abt-lnk" className="center-first">
        <div className="container text-center">
          <h2>+ servicios</h2>
          <Services />
        </div>
      </section>
      <Footer />
      <ChatBot />
      <GlobalScripts />
    </>
  );
}

export default CMS;